import { render, staticRenderFns } from "./TrainMenuLayout.vue?vue&type=template&id=4d43e62d&scoped=true"
import script from "./TrainMenuLayout.vue?vue&type=script&lang=js"
export * from "./TrainMenuLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d43e62d",
  null
  
)

export default component.exports